/**
 * The backend client: the one module that owns the base URL, `Authorization`,
 * `x-school-id`, `x-demo-mode`, timeouts, error mapping and response parsing
 * for calls from the web dashboard to the School Journey backend.
 *
 *   const app = await client.request({ method: 'GET', path: path`/v1/mobile-apps/${id}` }, GetMobileAppResponseSchema)
 *
 * Tests import `createTestBackendClient` from `./fake-transport` directly.
 * Server code imports `getServerBackendClient` from `@/lib/server/backend-client`,
 * never this barrel: it carries the React adapter.
 * Types (`BackendClient`, `Endpoint`, `RequestOptions`, …) are re-exported here
 * as their first consumer outside this directory lands; until then they live in
 * their own files.
 */

export { createBackendClient } from './client'
export { buildQueryString, path } from './endpoint'
export { ApiError, isApiError, isNotAvailableForActiveSchool } from './api-error'
export { fetchTransport, TransportError } from './transport'
export { wireDate, wireEnum } from './wire'
export { BackendClientProvider, useBackendClient } from './use-backend-client'
